module.exports = "pegasus_template/assets/theme6/medium/5.jpg";